import React, { useEffect, useRef, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import './xy.scss';

const XYInterface = ({zobject, attributes, width, height, x, y}) => { 
    let ref = useRef(undefined);
    let [coords, setCoords] = useState({x,y});
    let [moving, setMoving] =  useState(false);

    useEffect(() => {
        setCoords({x,y});
    }, [x,y, setCoords]);

    const onMouseMove = useCallback((e, force) => {
        if (!moving && !force) {
            return;
        }
        if (force) {
            setMoving(true);
        }
        let rect = ref.current.getBoundingClientRect();
        let x = (e.clientX - rect.left)/width;
        let y = 1-(e.clientY - rect.top)/height;
        zobject.effect.setXY(x,y);
        setCoords({x,y});
    }, [moving, setMoving, setCoords, width, height]);

    let fill = attributes["secondary-color"] || "white";
    let backgroundColor = attributes["primary-color"] || "black";
    let style = {
        backgroundColor
    };

    return (
        <svg
          style={style}
          ref={ref}
          onMouseUp={e => setMoving(false)}
          onMouseDown={e => onMouseMove(e, true)}
          onMouseMove={onMouseMove}
          width={width} height={height} className="xy-interface">
          <circle
            fill={fill}
            onMouseDown={(e) => {
                e.stopPropagation();
                setMoving(true);
            }}
            cx={coords.x*width} cy={(1-coords.y)*height} r={10}/>
        </svg>);
};

const mapStateToProps = (state, props) => {
    let {zobject} = props;
    if (!zobject.effect) {
        return {};
    }
  return {
      width: zobject.width,
      height: zobject.height,
      x: zobject.effect.x,
      y: zobject.effect.y,
      attributes: zobject.attributes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(XYInterface);
